function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageTextCircle02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 7.125H9M6 9.75H11.25M9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 9.89786 2.4253 10.7548 2.74355 11.5384C2.80446 11.6884 2.83491 11.7633 2.8485 11.824C2.86179 11.8833 2.86665 11.9271 2.86666 11.9879C2.86666 12.05 2.85539 12.1177 2.83283 12.253L2.3881 14.9214C2.34152 15.2009 2.31824 15.3406 2.36157 15.4416C2.3995 15.53 2.46996 15.6005 2.55839 15.6384C2.65942 15.6818 2.79914 15.6585 3.07857 15.6119L5.74699 15.1672C5.88231 15.1446 5.94998 15.1333 6.0121 15.1333C6.07286 15.1334 6.11675 15.1382 6.17604 15.1515C6.23666 15.1651 6.31164 15.1955 6.46162 15.2565C7.24523 15.5747 8.10214 15.75 9 15.75Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageTextCircle02);
export default __webpack_public_path__ + "static/media/message-text-circle-02.dd291426a3dbb7e2a46fd1b56e11edbb.svg";
export { ForwardRef as ReactComponent };